/**
 * Struktureret klient-logging. I produktion sendes fejl til Supabase
 * (client_errors-tabel) med best-effort, så drift kan følge med.
 */
import { supabase } from "@/lib/supabase/client";

type Level = "debug" | "info" | "warn" | "error";

function log(level: Level, message: string, context?: Record<string, unknown>) {
  const entry = { ts: new Date().toISOString(), level, message, ...context };
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console[level === "debug" ? "log" : level](message, context ?? "");
    return;
  }
  if (level === "error") {
    void supabase.from("client_errors").insert({
      message: message.slice(0, 1000),
      context: JSON.parse(JSON.stringify(context ?? {})),
      url: window.location.pathname,
      user_agent: navigator.userAgent.slice(0, 255),
    }).then(() => undefined, () => undefined);
  }
  // eslint-disable-next-line no-console
  console[level === "debug" ? "log" : level](JSON.stringify(entry));
}

export const logger = {
  debug: (m: string, c?: Record<string, unknown>) => log("debug", m, c),
  info: (m: string, c?: Record<string, unknown>) => log("info", m, c),
  warn: (m: string, c?: Record<string, unknown>) => log("warn", m, c),
  error: (m: string, c?: Record<string, unknown>) => log("error", m, c),
};
